import COLOR from "../../constants/colors";

const styles = {
  paleBackground: {
    background: COLOR.white,
  },
  mainArea: {
    padding: 24,
    minHeight: "100vh",
    marginTop: 64,
  },
};

export default styles;
